import React, { useContext, useEffect, useState } from 'react'
import layoutBgImg from '../../Images/layout/others.jpg'
import altImg from '../../Images/altImg.png'
import { useTranslation } from 'react-i18next'
import Layout from '../../Component/layout/main-layout'
import { DateRangeOutlined, RemoveRedEye } from '@mui/icons-material'
import { useLocation } from 'react-router-dom';
import { Context } from '../../Store/context';
import { GetSaleCard } from '../../api/Queries/get'

const Salecard = () => {
  const [sale, setSale] = useState([])
  const [mainImage, setMainImage] = useState('');
  const [smallImage1, setSmallImage1] = useState('');
  const [smallImage2, setSmallImage2] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation().pathname.split('/')[2];
  const { t } = useTranslation();
  const { showError } = useContext(Context);

  useEffect(() => {
    const getSaleCard = async () => {
      try {
        const res = await GetSaleCard(location)
        setSale(res.data)

        if (res.data) {
          setMainImage(res.data.photo1 || '');
          setSmallImage1(res.data.photo2 || '');
          setSmallImage2(res.data.photo3 || '');
        }
      } catch (error) {
        showError(error.message);
      }
    }
    getSaleCard()
  }, [location, showError])

  const handleImageClick = (smallImage, setSmallImage) => {
    const temp = mainImage;
    setMainImage(smallImage);
    setSmallImage(temp);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className='mb-20'>
      <Layout
        title={t('sale')}
        layoutBgImg={layoutBgImg}
      />
      <div className='media'>
        <div className='bg-white dark:bg-dark-box xl:flex gap-8
                        p-4 xl:p-8 mt-8'>
          <section className="xl:w-[50%]">
            {/* Main Image with transition class */}
            <img
              src={mainImage ? mainImage : altImg}
              alt="main auction"
              className="main-image object-contain w-full 
                   rounded-lg transition-image max-h-96
                   cursor-pointer"
              onClick={openModal}
            />

            {/* Small Images with transition class */}
            <div className="flex gap-2 mt-2 justify-center">
              {smallImage1 &&
                <img
                  src={smallImage1 ? smallImage1 : altImg}
                  alt="img2"
                  className="small-image w-20 h-20 object-contain 
                     cursor-pointer transition-image"
                  onClick={() => handleImageClick(smallImage1, setSmallImage1)}
                />
              }
              {smallImage2 &&
                <img
                  src={smallImage2 ? smallImage2 : altImg}
                  alt="img3"
                  className="small-image w-20 h-20 object-contain 
                     cursor-pointer transition-image"
                  onClick={() => handleImageClick(smallImage2, setSmallImage2)}
                />
              }
            </div>
          </section>
          <section className='xl:w-[45%] dark:text-dark-text'>

            <div className='flex border-b border-b-border pb-2 mt-4 xl:mt-0
                            items-center gap-8 dark:border-b-dark-border'>
              <h2 className='text-primary font-bold 
                             dark:text-dark-text text-xl'>
                {t('court_order')}
              </h2>
              <p className='flex items-center gap-1  dark:text-dark-text'>
                <DateRangeOutlined style={{ fontSize: '20px' }} />
                <span className='text-primary dark:text-dark-text
                                  text-2xl font-bold '>
                  {sale.lot}
                </span>
              </p>
            </div>

            <div className='flex gap-2 items-center my-3'>
              {t('type')} :
              <p className='bg-primary py-1 px-2
                            rounded-md text-white'>
                {sale.category}
              </p>
            </div>

            <div className='flex gap-2 items-center'>
              <p>{t('commission_basis')} :</p>
              <p className='text-primary text-xl dark:text-dark-text'>
                {sale.price}
              </p>
            </div>

            <div className='flex my-3 gap-6'>
              <p>
                {t('trading_place')} :
              </p>
              <p>
                {sale.location}
              </p>
            </div>

            <div className='flex gap-6 mb-2'>
              <p>
                {t('definition')}:
              </p>
              <p>
                {sale.description}
              </p>
            </div>

            <div className='flex gap-2'>
              <p>{t('contact_us')} :</p>
              <a href={`tel:${sale.phone_number}`}>
                {sale.phone_number}
              </a>
            </div>

            <div className='flex gap-2 items-center my-3'>
              {t('organizer')} :
              <p>
                {sale.organization}
              </p>
            </div>

            <div className='flex gap-6 items-center mt-4'>
              <p className='text-blackOpacity dark:text-dark-text
                                flex items-center gap-1'>
                <RemoveRedEye style={{ fontSize: '20px' }} />
                {sale.view_count}
              </p>
            </div>
          </section>

          {/* Fullscreen Modal Image*/}
          {isModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-75 
                            flex justify-center items-center z-50">
              <div className="relative w-screen h-screen flex
                              items-center justify-center">
                <img
                  src={mainImage}
                  alt="Full Screen"
                  className="w-[90%] h-[90%] object-contain"
                />
                <button
                  className="absolute top-4 right-4 text-white text-4xl"
                  onClick={closeModal}
                >
                  ×
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Salecard